// src/components/Onboarding/steps/EmailStep.tsx
import React, {useRef, useEffect} from "react";
import {OnboardingFormProps} from "../Types";
import flyingPaperPlaneGif from "../../../assets/animations/flying_paper_plane.gif";

const ThanksStep: React.FC<OnboardingFormProps> = ({formData, onChange}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div
        // className="primary-input-container"
    >
      <h1 style={{ marginTop: "0.25em" }}>Your Newsletter Is Being Prepared!</h1>

      <div
          className="primary-input-container"
          style={{
            maxWidth: "528px",
            lineHeight: "1.5",
            fontSize: "1.1em",
          }}
      >
        <img src={flyingPaperPlaneGif} alt="Flying paper plane"/>
        <p style={{ marginTop: "12px" }}>
          We'll notify you when your Template is ready for review.
        </p>
        <p>
          Until then, feel free to explore the platform to see how it works.
        </p>
        <p>Email <a href="mailto:team@withpotions.com" target="_blank" rel="noreferrer">team@withpotions.com</a> with any questions.</p>
      </div>
    </div>
  );
};

export default ThanksStep;
